import { useQueries } from '@tanstack/react-query';
import { useEarningsInsightsByEarningsId } from '../../insights/useEarningsInsightsByEarningsId';
import { createEarningsDataQueryOptions } from '../useEarningsData';
import {
  getDefaultPeriodsByEntityTag,
  getEarningsInsightsByEntityTag,
} from './useEarningsInsightsByEntities.utils';

export const useEarningsInsightsByEntities = (entityTags: string[]) => {
  const {
    data: earningsByTag,
    isFetching: isEarningsFetching,
    isError,
  } = useQueries({
    queries: entityTags.map(createEarningsDataQueryOptions),
    combine: results => ({
      data: entityTags.map((entityTag, index) => ({
        entityTag,
        earnings: results[index]?.data?.earnings ?? [],
        exchange: results[index]?.data?.earningExchange ?? '',
      })),
      isFetching: results.some(result => result.isFetching),
      isError: entityTags.length > 0 && results.every(result => result.isError),
    }),
  });

  const defaultPeriodsByEntityTag = getDefaultPeriodsByEntityTag(earningsByTag);

  const earningsIds = [...defaultPeriodsByEntityTag.values()]
    .map(entry => entry.latestEarningsData?.id)
    .filter((id): id is string => id != null);

  const { earningsInsightByEarningsId, isEarningsInsightsFetching } =
    useEarningsInsightsByEarningsId({
      earningsIds,
      isEnabled: !isEarningsFetching,
    });

  const byEntityTag = getEarningsInsightsByEntityTag(
    defaultPeriodsByEntityTag,
    earningsInsightByEarningsId
  );

  return {
    byEntityTag,
    isLoading: isEarningsFetching || isEarningsInsightsFetching,
    isError,
  };
};
